import {AfterViewInit, Component, Inject, OnDestroy, OnInit, ViewChild} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogTitle, MatDialogContent, MatDialogActions, MatDialogClose } from '@angular/material/dialog';
import {UnSubscribersDatasource} from './un-subscribers.datasource';
import {MatPaginator} from '@angular/material/paginator';
import { MatSort, MatSortHeader } from '@angular/material/sort';
import {merge} from 'rxjs';
import {tap} from 'rxjs/operators';
import {MessageBroadcastingService} from '../../api/services/message-broadcasting.service';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { FlexModule } from '@angular/flex-layout';
import { NgIf, AsyncPipe } from '@angular/common';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow } from '@angular/material/table';
import { MatButton } from '@angular/material/button';
import { PhoneNumberPipe } from '../../core/pipes/phone-number.pipe';
import { DateTimePipe } from '../../core/pipes/date-time.pipe';

export interface UnsubscribeListDialogData {
  phoneNumber: string;
}

@Component({
    selector: 'app-message-logs-dialog',
    template: `
    <h2 mat-dialog-title>Unsubscribed Phone Numbers</h2>
    <mat-dialog-content class="mat-typography" style="height: calc(100% - 95px); max-height: 100%">
      <div fxLayout="column" fxFlexFill>
        <div fxLayout="column" fxFlexFill class="spinner-container" *ngIf="dataSource.loading$ | async">
          <mat-spinner></mat-spinner>
        </div>
        <div fxFlex="auto" fxFlexFill class="table-container">
          <mat-table [dataSource]="dataSource" multiTemplateDataRows class="regular-table"
                     matSort matSortActive="createdOn" matSortDirection="desc" matSortDisableClear>
            <ng-container matColumnDef="phoneNumber">
              <mat-header-cell *matHeaderCellDef mat-sort-header="phoneNumber">Phone Number</mat-header-cell>
              <mat-cell *matCellDef="let row">
                {{row.phoneNumber | phoneNumber}}
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="name">
              <mat-header-cell *matHeaderCellDef >Name</mat-header-cell>
              <mat-cell *matCellDef="let row">
                {{row.name}}
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="companyName">
              <mat-header-cell *matHeaderCellDef >Company Name</mat-header-cell>
              <mat-cell *matCellDef="let row">
                {{row.companyName}}
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="email">
              <mat-header-cell *matHeaderCellDef >Email</mat-header-cell>
              <mat-cell *matCellDef="let row">
                {{row.email}}
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="createdOn">
              <mat-header-cell *matHeaderCellDef mat-sort-header="createdOn">Date</mat-header-cell>
              <mat-cell *matCellDef="let row">{{row.createdOn | dateTime: 'M/dd/yyyy hh:mm a'}}</mat-cell>
            </ng-container>
            <!-- Header and Row Declarations -->
            <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
            <mat-row *matRowDef="let row; columns: displayedColumns" class="call-logs-row"></mat-row>
          </mat-table>
        </div>
        <mat-paginator fxFlex="initial" [length]="dataSource.dataCount$ | async" [pageSize]="100"></mat-paginator>
      </div>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-button [mat-dialog-close]="false">Close</button>
    </mat-dialog-actions>
  `,
    styles: [
        '.mat-column-eventType { max-width: 80px;min-width: 80px;}',
        '.mat-column-createdOn { max-width: 200px;min-width: 200px;}',
        '.mat-column-tnFrom { max-width: 150px;min-width: 150px;}',
        '.mat-column-tnTo { max-width: 150px;min-width: 150px;}',
    ],
    standalone: true,
    imports: [
        MatDialogTitle,
        CdkScrollable,
        MatDialogContent,
        FlexModule,
        NgIf,
        MatProgressSpinner,
        MatTable,
        MatSort,
        MatColumnDef,
        MatHeaderCellDef,
        MatHeaderCell,
        MatSortHeader,
        MatCellDef,
        MatCell,
        MatHeaderRowDef,
        MatHeaderRow,
        MatRowDef,
        MatRow,
        MatPaginator,
        MatDialogActions,
        MatButton,
        MatDialogClose,
        AsyncPipe,
        PhoneNumberPipe,
        DateTimePipe,
    ],
})
export class UnsubscribeListDialogComponent implements OnInit, OnDestroy, AfterViewInit {

  displayedColumns: string[] = ['phoneNumber', 'name', 'companyName', 'email', 'createdOn'];
  dataSource: UnSubscribersDatasource;
  additionalFilter: any = {};
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  constructor(private messageBroadcastingService: MessageBroadcastingService,
              @Inject(MAT_DIALOG_DATA) public data: UnsubscribeListDialogData,
  ) {

  }

  ngOnInit() {
    this.additionalFilter.phoneNumber = this.data.phoneNumber;
    this.dataSource = new UnSubscribersDatasource(this.messageBroadcastingService);
  }

  ngOnDestroy() {
  }

  ngAfterViewInit(): void {
    /*this.filterChangeEvent?.subscribe(() => {
      this.paginator.pageIndex = 0;
    });*/

    this.sort.sortChange.subscribe(() => this.paginator.pageIndex = 0);

    merge(this.sort.sortChange, this.paginator.page)
      .pipe(
        tap(() => this.loadMessageLogs())
      )
      .subscribe();

    this.loadMessageLogs();
  }

  loadMessageLogs() {
    console.log('filter changed');
    this.dataSource.queryData({
      skip: this.paginator.pageIndex * this.paginator.pageSize,
      limit: this.paginator.pageSize,
      sort: [{field: this.sort.active, direction: this.sort.direction ? this.sort.direction.toUpperCase() : undefined}],
      phoneNumber: this.additionalFilter.phoneNumber,
      user: undefined
    });
  }
}
